import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { VirtualDataRoomPermissionType } from "@/models/virtual-data-room/VirtualDataroomPermissionType";
import { GuestUserDTO } from "@/types/GuestUserDTO";

export type VirtualDataRoomGuest = {
  guest: GuestUserDTO;
  permissionType: VirtualDataRoomPermissionType;
};

class VirtualDataRoomGuestService {
  private path: string;
  constructor(path: string) {
    this.path = path;
  }

  getAll(roomExternalId: string): Promise<ApiResponseV2<VirtualDataRoomGuest[]>> {
    return HttpClientV2.get(`${this.path}/all?roomExternalId=${roomExternalId}`);
  }

  updatePermissions(roomExternalId: string, dto: VirtualDataRoomGuest): Promise<ApiResponseV2<VirtualDataRoomGuest>> {
    return HttpClientV2.put(`${this.path}/update-permission?roomExternalId=${roomExternalId}`, dto);
  }

  delete(roomExternalId: string, dto: VirtualDataRoomGuest): Promise<ApiResponseV2<string>> {
    return HttpClientV2.delete(`${this.path}?roomExternalId=${roomExternalId}&guestExternalId=${dto.guest?.externalId}`);
  }

  createWithPermission(roomExternalId: string, list: VirtualDataRoomGuest[]): Promise<ApiResponseV2<VirtualDataRoomGuest[]>> {
    return HttpClientV2.post(`${this.path}/create?roomExternalId=${roomExternalId}`, {
      guests: list,
    });
  }

  getPermissionsByRoomExternalIdAndEmail(roomExternalId: string, email: string): Promise<ApiResponseV2<VirtualDataRoomPermissionType>> {
    return HttpClientV2.get(`${this.path}/permissions?roomExternalId=${roomExternalId}&email=${encodeURIComponent(email)}`);
  }
  deleteGuestFromRoom(roomExternalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.delete(`${this.path}/delete-guest-from-room?roomExternalId=${roomExternalId}`);
  }
}

export default new VirtualDataRoomGuestService("/api/virtual-data-room-guest");
